import { LoginBox } from "../components/loginBox";
import SvgIcon from "../components/SvgIcon";

function LoadingCircle() {
  // const translation = getTranslationJson(userBrowserLanguage());

  return (
    <div className="font-inter-24">
      <LoginBox>
        <header className="fflex flex-col mb-6 items-center justify-center">
          {/* <Header1>{translation.not_found_404 || "Page not Found 404"}</Header1> */}
          {/* <P>{translation.not_found_404_description || "Sorry, we couldn't find the page you were looking for."}</P> */}
        </header>
        <>
          <div className="flex items-center justify-center">
            <SvgIcon className=" text-7xl text-brand-green rounded-[40px] mb-2 p-3" name="loading-twotone-loop" />
          </div>

          {/* <div className="text-sm text-gray-600 mb-4">
            {translation.email_verification_successfull_description ||
              "You can now close this window and return to the login screen."}
          </div> */}
        </>
      </LoginBox>
    </div>
  );
}
export default LoadingCircle;
